import { render, staticRenderFns } from "./topic.vue?vue&type=template&id=5c62d32d&scoped=true&"
import script from "./topic.vue?vue&type=script&lang=js&"
export * from "./topic.vue?vue&type=script&lang=js&"
import style0 from "./topic.vue?vue&type=style&index=0&id=5c62d32d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c62d32d",
  null
  
)

export default component.exports